'use strict';

if (window.registerOutboundEntryController) {
    window.registerOutboundEntryController('eWaybillTrxCtrl', {
        isEWaybillMode: true,
        allowReceiverCustomerLookup: false,
        entryLabel: 'E-Waybill',
        saveHeaderText: 'Simpan E-Waybill',
        deleteHeaderText: 'Hapus E-Waybill',
        defaultDataUrl: '/e-waybill-entry-defaultdata',
        entryDataUrl: '/e-waybill-entry-data/',
        printUrl: '/e-waybill-print',
        apiBaseUrl: 'api/e-waybill',
        generateAwbUrl: 'api/e-waybill/generate-awb',
        chargePreviewUrl: 'api/e-waybill/charge-preview',
        shipperCustomerListUrl: 'api/e-waybill/customer-list?',
        shipperCustomerLookupUrl: 'api/e-waybill/customer-code/',
        receiverCustomerListUrl: 'api/e-waybill/receiver-list?',
        receiverCustomerLookupUrl: 'api/e-waybill/receiver-code/',
        showUploadButton: true,
        uploadModalTitle: 'Upload E-Waybill',
        uploadTemplateUrl: '/api/e-waybill-upload/template',
        uploadPrecheckUrl: '/api/e-waybill-upload/precheck',
        uploadUrl: '/api/e-waybill-upload/upload',
        deleteDeniedMessage: 'Anda tidak memiliki otoritas hapus e-waybill'
    });
}
